import * as React from 'react';
import { cn } from '../../utils/cn';

function Input({ className, type = 'text', ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      data-slot="input"
      type={type}
      className={cn(
        'h-9 w-full rounded border border-neutral-200 bg-white px-3 text-sm text-neutral-900 transition-colors outline-hidden',
        'placeholder:text-neutral-400',
        'focus:outline-none focus:ring-2 focus:ring-primary-500/30 focus:border-primary-500',
        'disabled:opacity-50 disabled:bg-neutral-50',
        'aria-invalid:border-danger aria-invalid:ring-2 aria-invalid:ring-danger/30',
        'file:text-neutral-900 file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium',
        className
      )}
      {...props}
    />
  );
}

export { Input };
